export const MEMBERSHIP_FORM = 'INFO_FORM';

export const FETCH_ALL_MEMBERSHIPS_START = 'FETCH_ALL_MEMBERSHIPS_START';
export const FETCH_ALL_MEMBERSHIPS_SUCCESS = 'FETCH_ALL_MEMBERSHIPS_SUCCESS';
export const FETCH_ALL_MEMBERSHIPS_ERROR = 'FETCH_ALL_MEMBERSHIPS_ERROR';

export const CREATE_MEMBERSHIP_START = 'CREATE_MEMBERSHIP_START';
export const CREATE_MEMBERSHIP_SUCCESS = 'CREATE_MEMBERSHIP_SUCCESS';
export const CREATE_MEMBERSHIP_ERROR = 'CREATE_MEMBERSHIP_ERROR';

export const EDIT_MEMBERSHIP_START = 'EDIT_MEMBERSHIP_START';
export const EDIT_MEMBERSHIP_SUCCESS = 'EDIT_MEMBERSHIP_SUCCESS';
export const EDIT_MEMBERSHIP_ERROR = 'EDIT_MEMBERSHIP_ERROR';

export const ARCHIVE_MEMBERSHIP_START = 'ARCHIVE_MEMBERSHIP_START';
export const ARCHIVE_MEMBERSHIP_SUCCESS = 'ARCHIVE_MEMBERSHIP_SUCCESS';
export const ARCHIVE_MEMBERSHIP_ERROR = 'ARCHIVE_MEMBERSHIP_ERROR';
